<template>
  <div class="form-group" v-bind:class="{ 'has-error': error }">
    <label v-if="label" :for="name">{{ label }}</label>
    <select type="text" @change="updateValue($event.target.value)" :name="name" :required="required" class="form-control">
      <option v-if="placeholder" value="">{{ placeholder }}</option>
      <option v-for="identifier in identifiers" :value="identifier.identifier" :selected="value == identifier.identifier">
        {{ identifier.identifier }}
        <template v-for="(attr, key) in identifier.attributes">{{ key > 0 ? ',': ' => ' }} {{ attr.name }}: <strong>{{ attr.value }}</strong></template>
      </option>
    </select>
    <span v-if="error" class="help-block" v-html="error"></span>
  </div>
</template>

<script>
  export default{
    name: 'InputIdentifiers',
    props: ['name', 'value', 'identifiers', 'required', 'label', 'placeholder', 'error'],
    methods: {
      updateValue (value) {
        this.$emit('input', value)
      }
    }
  }
</script>


// WEBPACK FOOTER //
// InputIdentifiers.vue?6be95faa